import { useQuery } from '@apollo/client';
import { GetAnalysisByPatientIdQuery } from '__generated__/graphql';
import { Input, List } from 'antd';
import { GET_ANALYSIS_BY_PATIENT_ID } from 'gql/patients/queries';
import { _debounce } from 'helpers/debounce';
import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ResultItem from './ResultItem';

interface IProps {
  patientId: string;
}

const PAGE_LIMIT = 10;
const debounce = _debounce();

const TestResults: FC<IProps> = ({ patientId }) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const variables = useMemo(
    () => ({
      query: {
        pagination: {
          page: page - 1,
          limit: PAGE_LIMIT
        },
        search
      },
      id: patientId
    }),
    [page, patientId, search]
  );

  const { data, loading } = useQuery<GetAnalysisByPatientIdQuery>(
    GET_ANALYSIS_BY_PATIENT_ID,
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
      variables
    }
  );

  const onSearch = (value: string) => {
    setPage(1);
    debounce(() => setSearch(value));
  };

  const results = data?.getAnalysisByPatientId?.data.results || [];
  const total = data?.getAnalysisByPatientId?.data.total || 0;

  return (
    <div>
      <List
        pagination={
          !!results.length && {
            position: 'bottom',
            align: 'center',
            total,
            pageSize: 10
          }
        }
        itemLayout="horizontal"
        dataSource={results}
        loading={loading}
        header={
          <Input
            size="large"
            placeholder={t('patient.search_by_title')}
            onChange={e => onSearch(e.target.value)}
          />
        }
        renderItem={item => {
          if (!item.id) {
            return null;
          }

          return (
            <ResultItem
              key={item.id}
              date={item.created_at}
              name={item.title || ''}
              id={item.id}
            />
          );
        }}
      />
    </div>
  );
};

export default TestResults;
